import Incident from '@/assets/icons/incident.svg?react';
import Route from '@/assets/icons/route-list.svg?react';
import Station from '@/assets/icons/station-list.svg?react';
import Incidents from '@/components/Incidents';
import Routes from '@/components/routes';
import PillTabs from '@/components/shared/pill-tabs';
import Stations from '@/components/stations';
import {
  SEARCH_PARAM_INCIDENTS,
  SEARCH_PARAM_ROUTES,
  SEARCH_PARAM_STATIONS,
} from '@/utils/constants/queries';

const BottomNav = () => {
  const tabData = [
    {
      key: SEARCH_PARAM_ROUTES,
      label: <Route className="size-5" />,
      content: <Routes />,
    },
    {
      key: SEARCH_PARAM_STATIONS,
      label: <Station className="size-5" />,
      content: <Stations />,
    },
    {
      key: SEARCH_PARAM_INCIDENTS,
      label: <Incident className="size-5" />,
      content: <Incidents />,
    },
  ];

  return (
    <div className="bg-white w-screen h-13 fixed bottom-0 z-51 inset-shadow-sm">
      <PillTabs tabs={tabData} />
    </div>
  );
};

export default BottomNav;
